import { BaseClientConfig } from './client/BaseClientConfig'
import { CommonServerConfig } from './common-server-config'

// TODO We probably need 3 types of config, clientConfig, serverConfig then transferToClientConfig
// Unsure of exact naming, but this concept needs to be made really clear
export function getClientConfig(
    serverConfig: CommonServerConfig,
    useInternalContentApi: boolean,
): BaseClientConfig {
    return {
        contentApi: useInternalContentApi
            ? serverConfig.internalContentApi
            : serverConfig.externalContentApi,
        publicUrl: serverConfig.publicUrl,
        publicHostname: serverConfig.publicHostname,
        akamaiImageManagerPolicy: serverConfig.akamaiImageManagerPolicy,
        baseAdUnitPath: serverConfig.baseAdUnitPath,
        baseAdUnits: serverConfig.baseAdUnits,
        launchDarklyClientId: serverConfig.launchDarklyClientId,
        launchDarklyClientTimeout: serverConfig.launchDarklyClientTimeout,
        iasClientId: serverConfig.iasClientId,
        oovvuuUrl: serverConfig.oovvuuUrl,
        oovvuuPath: serverConfig.oovvuuPath,
        snowPlowAppId: serverConfig.snowPlowAppId,
        snowPlowAppName: serverConfig.snowPlowAppName,
        moatVideoPartnerCode: serverConfig.moatVideoPartnerCode,
        brightcoveAccountId: serverConfig.brightcoveAccountId,
        subscribeTheWestUrl: serverConfig.subscribeTheWestUrl,
        connectIssuer: serverConfig.connectIssuer,
        connectClientId: serverConfig.connectClientId,
        integralPlacementLiveId: serverConfig.integralPlacementLiveId,
        integralPlacementVodId: serverConfig.integralPlacementVodId,
        integralAnId: serverConfig.integralAnId,
        parselyApikey: serverConfig.parselyApikey,
        prebidDebug: serverConfig.prebidDebug,
        prebidAppNexusId: serverConfig.prebidAppNexusId,
        prebidIxId: serverConfig.prebidIxId,
        sectionDomainsRedirect: serverConfig.sectionDomainsRedirect,
        hostnameRedirectsEnabled: serverConfig.hostnameRedirectsEnabled,
        ampGtmId: serverConfig.ampGtmId,
        gtmTrackingId: serverConfig.gtmTrackingId,
        nielsenAmpApid: serverConfig.nielsenAmpApid,
        nielsenApn: serverConfig.nielsenApn,
        nielsenSiteName: serverConfig.nielsenSiteName,
        contentfulStaticSiteEndpoint: serverConfig.contentfulStaticSiteEndpoint,
        firehoseTopicName: serverConfig.firehoseTopicName,
        userPollServiceEndpoint: serverConfig.userPollServiceEndpoint,
        apiCallerHeader: serverConfig.apiCallerHeader,
        sectionAdPathMapping: serverConfig.sectionAdPathMapping,
        cricketWidgetLink: serverConfig.cricketWidgetLink,
        liveBlogApi: serverConfig.liveBlogApi,
        liveBlogSocketUrl: serverConfig.liveBlogSocketUrl,
        theWestLiveStationId: serverConfig.theWestLiveStationId,
        coralUrl: serverConfig.coralUrl,
        chartbeatId: serverConfig.chartbeatId,
        recaptureSiteKey: serverConfig.recaptureSiteKey,
        sendgridEnv: serverConfig.sendgridEnv,
        statsPerformToken: serverConfig.statsPerformToken,
        nielsenApids: serverConfig.nielsenApids,
        websocketServiceEndpoint: serverConfig.websocketServiceEndpoint,
    }
}
